module.exports = __webpack_public_path__ + "img/ico-notif-free.3fee803a.svg";